// ✅ Updated Khadyajma.jsx
// Note: Debit/Credit UI translated using t(...), but excellentdairy value remains "Debit" / "Credit"

import React, { useEffect, useRef, useState, useContext } from 'react'
import './Khadyajma.css'
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt } from '@iconscout/react-unicons'
import { useTranslation } from "react-i18next";
import Globalcontext from '../../Context/Globalcontext';
import Khsale from '../Khsale/Khsale';

const Khadyajma = (props) => {
  const { t } = useTranslation();

  const inputRefs = useRef([]);
  const [newedit, setNewedit] = useState("new");

  const [input, setInput] = useState({
    date: new Date().toISOString().substr(0, 10),
    kno: "",
    name: "",
    type: "Credit",      // ✅ keep excellentdairy value
    amt: "",
    remark: "-"
  });

  const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);
  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [khnames, setKhnames] = useState([]);
  const [value, setValue] = useState('');
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [stock, setStock] = useState();
  const [sredit, setSredit] = useState('');
  const [mastermenu, setMastermenu] = useState(true);
  const [kopen, setkopen] = useState(0);
  const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
  const [transitionEnded, setTransitionEnded] = useState(true);

  const cellStyle = {
    border: '1px solid black',
    padding: '4px'
  };

  const printKhadyajma = () => {
    const content = document.getElementById('print-receipt-khadyajma');
    const kendraTitle = localStorage.getItem('kendra') || '';
    const kno = input.kno || '';
    const name = input.name || '';
    const dt = input.date || '';
    const type = input.type || 'Credit'; // ✅ excellentdairy value
    const typeLabel = (type === "Debit") ? t("khadyajma.type.debit") : t("khadyajma.type.credit"); // ✅ translated label
    const amt = input.amt || '';
    const remark = (input.remark && input.remark !== "") ? input.remark : "-";

    if (!content) {
      alert("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=300,height=500');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page { size: 58mm auto; margin: 0; }
            body { margin: 0; font-family: sans-serif; font-size: 12px; }
            .center-title { text-align: center; font-size: 11px; font-weight: bold; margin: 6px 0 2px; }
            .subinfo { font-size: 9px; font-weight: bold; margin-left: 1px; margin-bottom: 6px; line-height: 1.4; }
            .subinfo-row { display: flex; justify-content: space-between; margin-right: 6px; }
            table { border-collapse: collapse; width: 100%; margin-top: 10px; }
            th, td { border: 2px solid black; padding: 4px; text-align: center; }
            .thanks { text-align: center; font-weight: bold; font-size: 10px; margin-top: 12px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="center-title">${kendraTitle}</div>

          <div class="subinfo">
            <div class="subinfo-row">
              <span>${t("khadyajma.print.accNo")}: ${kno}</span>
              <span>${t("khadyajma.print.date")}: ${dt}</span>
            </div>
            <div>${t("khadyajma.print.name")}: ${name}</div>
            <div class="subinfo-row">
              <span>${t("khadyajma.print.type")}: ${typeLabel}</span>
              <span>${t("khadyajma.print.amount")}: ₹${amt}</span>
            </div>
            <div>${t("khadyajma.print.remark")}: ${remark}</div>
          </div>

          ${content.innerHTML}

          <div class="thanks">---------</div>
          <div class="thanks">${t("khadyajma.print.thanks")}</div>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  function handleEnterKey(event, currentIndex) {
    if (event.key === 'Enter' || event.key === "Tab") {
      event.preventDefault();
      const nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    }

    if (event.key === 'Backspace' && (
      (event.target.tagName === 'INPUT' && event.target.value === '') ||
      (event.target.tagName === 'SELECT' && (
        (event.target.name === 'type' && event.target.value === 'प्रकार निवडा')
      ))
    )) {
      event.preventDefault();

      let prevIndex = currentIndex - 1;
      while (prevIndex >= 0) {
        const prevElement = inputRefs.current[prevIndex];
        if (prevElement) {
          if ((prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') && prevElement !== event.target) {
            prevElement.focus();
            break;
          } else prevIndex--;
        } else prevIndex--;
      }
    }
  }

  const handleChange = async (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;
    setInput(value => ({ ...value, [name]: valuecurrent }));
  }

  useEffect(() => {
    if (input.kno === "") {
      setInput(prevInput => ({
        ...prevInput,
        kno: "",
        name: "",
        type: "Credit", // ✅ default
        amt: "",
        remark: "",
      }))
      setNewedit("new");
    } else {
      let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
      for (let i = 0; i < custlisttemp.length; i++) {
        setInput(prevInput => ({ ...prevInput, name: '' }));
        const user = custlisttemp[i];
        if (user.kno === input.kno) {
          setInput(prevInput => ({ ...prevInput, name: user.cname }));
          break;
        }
      }
    }
  }, [input.kno])

  function handleEnterKeybutton(event, currentIndex) {
    if (event.key === 'Enter') {
      event.preventDefault();
      savekhadyajma();

      let nextIndex = null;
      if (currentIndex === 0) {
        nextIndex = (input.name !== "") ? currentIndex + 1 : currentIndex;
      } else nextIndex = currentIndex + 1;

      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    } else if (event.key === "Backspace") {
      if (event.target.tagName === "BUTTON") {
        if (inputRefs.current[4]) inputRefs.current[4].focus();
      }
    }
  }

  const savekhadyajma = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.date === "" || input.kno === "" || input.name === "" || input.type === "" || input.amt === "" || input.remark === "") {
      notifyerror(t("khadyajma.toast.incompleteEntry"));
      return;
    }

    let rawData = {
      date: input.date,
      kno: input.kno,
      type: input.type, // ✅ sends "Debit"/"Credit"
      amt: input.amt,
      remark: input.remark,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      flag: newedit,
      sredit: sredit,
    }

    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/savekhadyajma.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (newedit === "new") {
        if (response.data.trim() === "Saved.") notify(t("khadyajma.toast.entrySaved"));
      } else {
        if (response.data.trim() === "updated.") notify(t("khadyajma.toast.entryUpdated"));
      }

      setInput(prevInput => ({
        ...prevInput,
        kno: "",
        name: "",
        type: "Credit",
        amt: "",
        remark: "",
      }))
      setSredit("");
      setNewedit("new");
      getkhadyajma();

      if (inputRefs.current[1]) inputRefs.current[1].focus();
    }).catch(err => console.log(err));
  }

  useEffect(() => {
    getkhadyajma();
    if (inputRefs.current[1]) inputRefs.current[1].focus();
  }, [])

  async function getkhadyajma() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/getkhadyajma.php', {
      date: input.date,
      time: input.time,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2
    }).then(function sample(response) {
      if (response.data) {
        setDataSource(response.data);
        setTimeout(() => props.setProgress(100), 200);
      }
    }).catch(err => console.log(err));
  }

  const handleedit = (sr, date, rno, amt, remark, type) => {
    setInput({ sr: sr, date: date, kno: rno, amt: amt, remark: remark, type: type || "Credit" })
    setNewedit("edit");
    setSredit(sr);
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const openratibvikri = () => {
    setsubmenu("ksale");
    setHeadname(t("khadyajma.head.feedSale"));
    return <Khsale setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} visibility={visibility} />
  };

  const visibility = () => {
    localStorage.setItem("glcustsr", "");
    setTransitionEnded(false);
    setMastermenu(!mastermenu);
    setkopen(0);
    setsubmenu("");
    setHeadname(t("khadyajma.head.dailyTransactions"));
  }

  return (
    <div className="khadyamain">
      <div className="firstrowkhadya">
        <img onClick={openratibvikri} className='back' src={back} alt="" />
        <div className="colmainkhadya">
          <div className="firstrow2">
            <div className="rowsank">
              <div className="mb-2">
                <span className='subheadsank'>{t("khadyajma.label.date")}</span>
                <input
                  onKeyDown={e => handleEnterKey(e, 0)}
                  ref={ref => (inputRefs.current[0] = ref)}
                  type="date"
                  className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                  autoComplete='off'
                  id="date"
                  name="date"
                  value={input.date}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='linekh' />

      <div className="row1ratibjma">
        <div className="mb-2">
          <span className='subheadsank'>{t("khadyajma.label.accNo")}</span>
          <input
            onKeyDown={e => handleEnterKey(e, 1)}
            ref={ref => (inputRefs.current[1] = ref)}
            type="number"
            className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
            autoComplete='off'
            id="kno"
            name="kno"
            value={input.kno}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <span className='subheadsank'>{t("khadyajma.label.memberName")}</span>
          <input
            type="text"
            disabled
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            autoComplete='off'
            id="name"
            name="name"
            value={input.name}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='linekh' />

      <div className="row1ratibjma">
        <div className="mb-2">
          <span className='subheadsank'>{t("khadyajma.label.type")}</span>

          {/* ✅ UI translated, value sent to excellentdairy remains "Debit"/"Credit" */}
          <select
            onKeyDown={e => handleEnterKey(e, 2)}
            ref={ref => (inputRefs.current[2] = ref)}
            value={input.type}
            name='type'
            id='type'
            onChange={handleChange}
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
          >
            <option value="Credit">{t("khadyajma.type.credit")}</option>
            <option value="Debit">{t("khadyajma.type.debit")}</option>
          </select>
        </div>

        <div className="mb-2">
          <span className='subheadsank'>{t("khadyajma.label.amount")}</span>
          <input
            onKeyDown={e => handleEnterKey(e, 3)}
            ref={ref => (inputRefs.current[3] = ref)}
            type="number"
            className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
            autoComplete='off'
            id="amt"
            name="amt"
            value={input.amt}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <span className='subheadsank'>{t("khadyajma.label.remark")}</span>
          <input
            type="text"
            onKeyDown={e => handleEnterKey(e, 4)}
            ref={ref => (inputRefs.current[4] = ref)}
            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            autoComplete='off'
            id="remarkkhjma"
            name="remark"
            value={input.remark}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row1kh">
        <div className="mb-2">
          <button
            onClick={savekhadyajma}
            onKeyDown={e => handleEnterKeybutton(e, 0)}
            ref={ref => (inputRefs.current[5] = ref)}
            type="submit"
            className="btn btn-primary mx-1 sanksmall"
          >
            {newedit === "new" ? t("khadyajma.btn.save") : t("khadyajma.btn.update")}
          </button>

          <button type="submit" className="btn btn-primary mx-1 sanksmall">
            {t("khadyajma.btn.report")}
          </button>

          <button
            type="button"
            className="btn btn-primary mx-1 sanksmall"
            onClick={printKhadyajma}
          >
            {t("khadyajma.btn.print")}
          </button>
        </div>
      </div>

      <div className="firstrow2">
        <div className="table-containeruchal">
          <table id="myTable" className="table table-bordered">
            <thead>
              <tr>
                <th className='thsmall' scope="col">{t("khadyajma.table.no")}</th>
                <th className='thsmall' scope="col">{t("khadyajma.table.date")}</th>
                <th className='thsmall' scope="col">{t("khadyajma.table.accNo")}</th>
                <th className='thsmall' scope="col">{t("khadyajma.table.name")}</th>
                <th className='thsmall' scope="col">{t("khadyajma.table.amount")}</th>
                <th className='thsmall' scope="col">{t("khadyajma.table.action")}</th>
              </tr>
            </thead>
            <tbody>
              {value.length > 0 ? tableFilter.map((user, index) =>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.date}</td>
                  <td>{user.rno}</td>
                  <td>{user.name}</td>
                  <td>{user.amt}</td>
                </tr>
              )
                :
                DataSource.map((user, index) =>
                  <tr key={index}>
                    <td className='thsmall'>{index + 1}</td>
                    <td className='thsmall'>{user.date}</td>
                    <td className='thsmall'>{user.kno}</td>
                    <td className='thsmall'>{user.name}</td>
                    <td className='thsmall2'>{user.amt}</td>
                    <td>
                      <UilEditAlt
                        onClick={() => { handleedit(user.sr, user.date, user.kno, user.amt, user.remark, user.type) }}
                        className="icsank"
                      />
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      </div>

      <div id="print-receipt-khadyajma" style={{ display: 'none' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12px', textAlign: 'center' }}>
          <thead>
            <tr>
              <th style={cellStyle}>{t("khadyajma.print.tableType")}</th>
              <th style={cellStyle}>{t("khadyajma.print.tableAmount")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={cellStyle}>
                {(input.type === "Debit") ? t("khadyajma.type.debit") : t("khadyajma.type.credit")}
              </td>
              <td style={cellStyle}>₹{input.amt}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ToastContainer />
    </div>
  )
}

export default Khadyajma
